export default "__VITE_ASSET__pkf6vO7X__"